export type JwtPayload = {
  // eslint-disable-next-line
  [key: string]: any;
  // Registered Claim Names
  iss?: string; // Issuer
  sub?: string; // Subject
  aud?: string[] | string; // Audience
  exp?: number; // Expiration Time (unix)
  nbf?: number; // Not Before (unix)
  iat?: number; // Issued At (unix)
  jti?: string; // JWT ID
  user_id?: string
}

/**
 * Decodes a JWT token encoded as a base64 string.
 * @param token The base64 string.
 */
export const decodeJwt = (token?: string): JwtPayload | undefined => {
  if (token === undefined) return undefined;

  const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    // Supports base64 encoded UTF-8 strings, see Decoding base64 ⇢ UTF-8
    // from the accepted answer in https://stackoverflow.com/a/30106551
    window.atob(base64).split('').map(
      c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    ).join('')
  );
  return JSON.parse(jsonPayload);
};

/**
 * Determines whether a JWT is expired or not, with some margin seconds. This is, the token counts
 * is considered as expired if it expires before <code>marginSeconds</code> from now.
 *
 * @param token The JWT token to check.
 * @param marginSeconds The amount of seconds the token must be alive for.
 */
export const isTokenExpired = (token: JwtPayload | undefined, marginSeconds: number): boolean =>
  token?.exp !== undefined
    ? (token.exp - marginSeconds) * 1000 < new Date().getTime()
    : true;
